<template>
  <el-dialog
    title="新增表彰/投诉数据"
    :visible.sync="addCommendDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="1200px"
    center>
    <el-form :model="residentForm" :rules="rules" ref="residentForm" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：" prop="project">
            <el-input :value="project" readonly placeholder="请输入社区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：" prop="communityId">
            <el-select v-model="residentForm.communityId" placeholder="请选择小区" style="width: 100%" @change="twoChange">
              <el-option
                v-for="item in communityList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="志愿者队长：" prop="yuangongId">
            <el-select v-model="residentForm.yuangongId" placeholder="请选择员工" style="width: 100%">
              <el-option
                v-for="item in yuangongList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型：" prop="type">
            <el-select v-model="residentForm.type" class="w-all" placeholder="请选择类型">
              <el-option
                v-for="item in biaozhangList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="原由：" prop="content">
            <el-input v-model="residentForm.content" placeholder="请输入原由"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('residentForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('residentForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {biaozhangList, optionList} from "@/utils/utils";
import {getAdminByXiaoquId, getXiangMuList, getXiaoQuList} from "@/api/common";
import {addAdminComment} from "@/api/biaozhang";

export default {
  name: "addCommendDialog",
  props: {
    addCommendDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isclear: false,
      project: '',
      projectId: '',
      communityList: [],
      yuangongList: [],
      biaozhangList: optionList(0, biaozhangList),

      residentForm: {
        communityId: '',
        yuangongId: '',
        type:'',
        content:''
      },
      rules: {
        communityId: [{required: true, message: '请选择小区', trigger: 'change'}],
        yuangongId: [{required: true, message: '请选择员工', trigger: 'change'}],
        type: [{required: true, message: '请选择类型', trigger: 'change'}],
        content: [{required: true, message: '请输入原由', trigger: 'blur'}],
      }
    }
  },
  created() {
    this.getComminity()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await addAdminComment(
        this.residentForm.communityId,
        this.residentForm.yuangongId,
        this.residentForm.type,
        this.residentForm.content,
        '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  获取当前员工管理的社区和小区
    async getComminity() {
      let _data = await getXiangMuList()
      this.project = _data.data[0].name
      this.projectId = _data.data[0].id
      let _data2 = await getXiaoQuList(_data.data[0].id)
      this.communityList = _data2.data
    },
    twoChange(e) {
      if (e) this.getYuangongList(e)
    },
    async getYuangongList(id) {
      let _data = await getAdminByXiaoquId(id)
      this.yuangongList = _data.data
    },
  },
  watch: {}
}
</script>

<style scoped lang="scss">

</style>
